import type { RouteObject } from 'react-router';

import { StyleScope } from '@/features/shared/style-scope';

export const dashboardRoutes: RouteObject[] = [
    {
        path: '',
        element: <StyleScope name='dashboard-ui' />,
        children: [
            {
                path: 'home',
                async lazy() {
                    const { homePage } = await unwrapFeatures();

                    return homePage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'check-login',
                async lazy() {
                    const { checkLoginPage } = await unwrapFeatures();

                    return checkLoginPage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
        ],
    },
];

async function unwrapFeatures() {
    const features = await import('dashboard/features');

    return features.default;
}
